
import Form from "./Form.vue";
import ConfiguracaoData from "./ConfiguracaoData";
import { mapGetters } from "vuex";

export default {
  name: "app-configuracoes-create",
  data() {
    return {
      configuracao: new ConfiguracaoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
